module.exports = "https://www.gc-qa.gnp.com.mx/3c58b1368492ca6528d4674bc00cfc5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/playstore.svg
// module id = 8158
// module chunks = 0